/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'copyright-status-label',
  template: `
    <span class="label {{labelClass[copyrightStatus]}}">{{ "creative.copyrightStatus." + copyrightStatus | translate }}</span>
  `
})
export class CopyrightStatusComponent implements OnInit {
  @Input() copyrightStatus: string;
  labelClass: any;
  translation: string;

  constructor(public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.labelClass = {};
    this.labelClass.UNSPECIFIED = 'label-warning';
    this.labelClass.ADVERTISER_CONFIRMED = 'label-success';
    this.labelClass.ADVERTISER_UNCONFIRMED = 'label-danger';
  }
}
